import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { apiThatThrows } from "../api";

export function useAppsApi() {
  const dispatch = useDispatch();

  const getPublishedApplicationsPaginated = useCallback(
    async (queryParams, forAdmin) => {
      let response;
      if (forAdmin) {
        response = await dispatch(
          apiThatThrows.getDistributionApplicationsPaginated.action({
            queryParams,
          })
        );
      } else {
        response = await dispatch(
          apiThatThrows.getMyDistributionApplicationsPaginated.action({
            queryParams,
          })
        );
      }

      return response;
    },
    [dispatch]
  );

  const getApplication = useCallback(
    (appId) => {
      return dispatch(
        apiThatThrows.getApplication.action({
          params: { id: appId },
        })
      );
    },
    [dispatch]
  );

  return { getApplication, getPublishedApplicationsPaginated };
}
